import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.a.withConfig({
  displayName: "Inner",
  componentId: "sc-1n6b2af-0"
})(["display:flex;flex-direction:column;justify-content:space-between;min-height:160px;border:1px solid ", ";border-radius:8px;box-shadow:", ";background-color:", ";font-size:16px;line-height:18px;text-align:center;:hover{box-shadow:", ";}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lightBlack;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.cardsBackgroundColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.extraBlack;
}, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 180px;\n  "]))));